module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "drag-item",
      rawName: "v-drag-item"
    }],
    style: ({
      top: _vm.zoneTop,
      left: _vm.zoneLeft,
      width: _vm.zoneWidth,
      height: _vm.zoneHeight
    })
  }, [_c('ul', {
    directives: [{
      name: "change-size",
      rawName: "v-change-size"
    }],
    staticClass: "hz-m-box",
    class: {
      'hz-z-hidden': _vm.tooSmall,
      'hz-m-hoverbox': !_vm.hideZone
    }
  }, [_c('li', {
    staticClass: "hz-u-index",
    attrs: {
      "title": ("热区" + (_vm.index + 1))
    }
  }, [_vm._v(_vm._s(_vm.index + 1))]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideZone),
      expression: "!hideZone"
    }],
    staticClass: "hz-u-close hz-icon hz-icon-trash",
    attrs: {
      "title": "删除该热区"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delItem(_vm.index)
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "hz-u-square hz-u-square-tl",
    attrs: {
      "data-pointer": "dealTL"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "hz-u-square hz-u-square-tc",
    attrs: {
      "data-pointer": "dealTC"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "hz-u-square hz-u-square-tr",
    attrs: {
      "data-pointer": "dealTR"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "hz-u-square hz-u-square-cl",
    attrs: {
      "data-pointer": "dealCL"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "hz-u-square hz-u-square-cr",
    attrs: {
      "data-pointer": "dealCR"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "hz-u-square hz-u-square-bl",
    attrs: {
      "data-pointer": "dealBL"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "hz-u-square hz-u-square-bc",
    attrs: {
      "data-pointer": "dealBC"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "hz-u-square hz-u-square-br",
    attrs: {
      "data-pointer": "dealBR"
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b9c7896", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b9c7896"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-hotzone/lib/components/Zone.vue
// module id = 2571
// module chunks = 0